import { axios } from '@/request-clients/axios';
import { ChatAttachment } from '@my-ipractice/types';
import { useQuery } from '@tanstack/react-query';

export const useGetSharedAttachments = () => {
  return useQuery<ChatAttachment[]>({
    queryFn: async () => {
      const url = `clients/chat/shared-attachments`;
      const response = await axios.get(url);
      return response.data;
    },
    queryKey: ['shared-attachments'],
    meta: {
      errorMessage: 'Error fetching shared attachments',
    },
  });
};
